import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../service/user.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.css']
})
export class PasswordResetComponent implements OnInit {
  public forgotForm: FormGroup;
  email = ''
  emailErr: string
  step = 1
  loading = false

  //translations
  lan: string
  err1: string
  err2: string
  err3: string
  err4: string

  constructor(
    private builder: FormBuilder,
    private userService: UserService,
    public translate: TranslateService,
    private _snackBar: MatSnackBar) {

    this.forgotForm = this.builder.group({
      email: [null, [Validators.required, Validators.email]],
    });
    this.getTranslatedStrings()
    this.lan = localStorage.getItem("lan")
  }

  getTranslatedStrings() {
    this.translate.get(['REG_ERR2', 'REG_ERR3', 'FP_P3', 'FP_P4'])
      .subscribe(translations => {
        this.err1 = translations['REG_ERR2']
        this.err2 = translations['REG_ERR3']
        this.err3 = translations['FP_P3']
        this.err4 = translations['FP_P4']
      })
  }

  ngOnInit() {

  }

  clearErr() {
    this.emailErr = ''
  }

  focusOutCheck() {
    if (this.forgotForm.controls.email.value === null) {
      this.emailErr = this.err1
    }
    else if (this.forgotForm.controls.email.status === "INVALID") {
      this.emailErr = this.err2
    }
  }


  resetPassword() {

    if (this.forgotForm.controls.email.value === null) {
      this.emailErr = this.err1
    }
    else if (this.forgotForm.controls.email.status === "INVALID") {
      this.emailErr = this.err2
    }
    else {
      //NO ERRORS!
      this.loading = true
      this.userService.askToReset({ email: this.forgotForm.controls.email.value, language: this.lan })
        .then(resp => {
          this.loading = false

          if (resp.status == 200) {
            this.step++ //show success message
          }
        })
        .catch(e => {
          this.loading = false

          if (e.status == 404) {
            this._snackBar.open(this.err4, "", {
              duration: 5000,
            });
          }
          else
            this._snackBar.open(this.err3, "", {
              duration: 5000,
            });
        })
    }
  }
}
